export const randomString = () => Math.random().toString(36).substring(2, 15) +
  Math.random().toString(36).substring(2, 15);

export const pickWrapperClasses = (isLast) => {
  if (!('VUE_APP_PICK_STYLE' in process.env)) {
    return `p-3 ${isLast ? 'mb-1' : 'mb-5'}`;
  }

  let pickStyleSettings = process.env.VUE_APP_PICK_STYLE.split('|');
  let bgShouldBeLight = pickStyleSettings.includes('hasLeftBorder');
  let colorScheme = process.env.VUE_APP_PICK_COLOR || 'primary';
  let classes = {
    'boxed': 'box',
    'hasLeftBorder': `border-l-${colorScheme}`,
    'hasBackground': `has-background-${colorScheme}${bgShouldBeLight ? '-light' : ''}`
  };
  let classList = pickStyleSettings.map(setting => classes[setting]).join(' ');

  if (!pickStyleSettings.includes('box')) {
    classList += ' p-3';
  }

  classList += isLast ? ' mb-1' : ' mb-5';

  return classList;
}

export const pickColumnClasses = () => {
  if (!('VUE_APP_PICK_STYLE' in process.env)) {
    return `border-l-${process.env.VUE_APP_PICK_COLOR || 'primary'}`;
  }

  return '';
}

export const serviceWrapperClasses = () => {
  let style = process.env.VUE_APP_SERVICE_STYLE || 'boxed';

  if (style === 'boxed') return 'box';

  return 'px-3 py-3 mb-5';
}

export const adjustTSSRiskAmounts = (picks) => {
  return picks.map(pick => {
    if (pick.type === 'Parlay') {
      return pick;
    }

    let odds = pick.gain / pick.risk;

    if (odds >= 1) {
      return pick;
    }

    let risk = pick.risk / odds;
    let gain = pick.risk;

    pick.risk = parseFloat(risk.toFixed(2));
    pick.gain = parseFloat(gain.toFixed(2));
    return pick;
  })
}

// DO NOT INCLUDE TRAILING SLASHES. THOSE ARE ADDED LATER ON.
export const publicRoutes = ['/login', '/reset-forgotten-pass', '/sign-up', '/us'];

export const addWriteUpPromo = (pick, picks, more, promoAdded, promoAddedCb) => {
  let {type, homeTeam, awayTeam, dateTime, id} = pick;
  let isStale = dateTime < new Date().getTime();

  if (promoAdded || isStale || type === 'Parlay') {
    return pick;
  }

  let matchingPendingPick;

  more.forEach(capper => {
    if (matchingPendingPick) return;

    let pickMatches = capper.pending.find(pick => {
      return pick.type !== type &&
        pick.homeTeam === homeTeam &&
        pick.awayTeam === awayTeam &&
        pick.dateTime === dateTime;
    });

    if (pickMatches) {
      matchingPendingPick = {capper, pick: pickMatches};
    }
  });

  let matchingPick = picks
    .filter(pick => pick.id !== id)
    .some(pick => {
      let matchingPendingType = matchingPendingPick ? matchingPendingPick.type : '';
      return matchingPendingType === pick.type;
    })

  if (matchingPendingPick && !matchingPick) {
    pick.matchingPendingPick = matchingPendingPick;
    promoAddedCb();
  }

  return pick;
}

export const isThanksPage = query => {
  return [
    'item',
    'cbreceipt',
    'time',
    'cbpop',
    'cname',
    'cemail',
    'ccountry',
    'czip'
  ].every(param => param in query)
}

/*function getCSSAndInline(element) {
  let styles = getComputedStyle(element);
  let allowedPropertyNames = [
    'font',
    'color',
    'margin',
    'margin-bottom',
    'margin-top',
    'margin-left',
    'margin-right',
    'text-transform',
    'padding',
    'padding-left',
    'padding-top',
    'padding-right',
    'padding-bottom',
    'display',
    'text-align',
    'position',
    'background-color',
    'background',
    'border',
    'border-radius',
    'box-shadow',
    'box-sizing',
    'font-weight',
    'letter-spacing',
    'font-size',
    'font-weight',
    'line-height',
    'font-style',
    'align-items',
    'justify-content',
    'flex-basis',
    'flex-grow',
    'flex-shrink',
    'flex-wrap'
  ];

  for (let i = styles.length; i--;) {
    let name = styles.item(i);
    let val = styles.getPropertyValue(name);

    if (allowedPropertyNames.includes(name)) {
      element.style[name] = val;
      element.style.fontFamily = 'Arial, sans-serif'
    }
  }
}

function inlineCSSToChildrenElements(parentElement) {
  Array.from(parentElement.querySelectorAll('*'))
    .forEach(el => {
      getCSSAndInline(el);
    })
}

// From mobile view, find element that embodies service advertisements `AvailableCapper`. Then in javascript console...
inlineCSSToChildrenElements($0);
copy($0);
// Then send the copied html*/
